<div class='page-body flexColumn'>
  <div class='page-header-body flexRow' style='z-index: 999 !important; opacity: 1'>
    <div class='flexFull'></div>
    <div class='flexRow header-info-box'>
      <img *ngIf="cache['head_img'] != ''" src="{{ cache['head_img'] }}" alt='' class='user-avatar clickEle'
           (click)='toHome()' />
      <ng-container *ngIf="cache['head_img'] == ''">
        <img *ngIf="cache['sex_id'] == 2" src='assets/man.png' class='user-avatar clickEle' alt='人员头像'
             (click)='toHome()' />
        <img *ngIf="cache['sex_id'] == 3" src='assets/woman.png' class='user-avatar clickEle' alt='人员头像'
             (click)='toHome()' />
      </ng-container>
      <div class='user-info-box flexColumn'>
        <div class='flexRow'>
          <div class='user-name'>{{ cache['name'] }}</div>
          <!--          <div class="role-name">管理员</div>-->
        </div>
        <div class='user-mobile'>{{ cache['mobile'] }}</div>
      </div>
      <div class='flexFull'></div>
      <!--      <div class="setting-button clickEle flexRow defaultRadius">-->
      <!--        <i nz-icon nzIconfont="icon_message" class="icon-setting"></i>-->
      <!--        <div class="setting-button-text">通知</div>-->
      <!--      </div>-->
      <div class='setting-button clickEle flexRow defaultRadius pr-12 reload-button' style='width: auto'
           (click)='reload()'>
        <i nz-icon nzIconfont='icon_shuaxin' class='icon-setting mr0'></i>
      </div>
      <div class='space-mark mr-xs'></div>
      <div class='setting-button clickEle flexRow defaultRadius' (click)='jumpToSetting()'>
        <i nz-icon nzIconfont='icon_setting' class='icon-setting'></i>
        <div class='setting-button-text'>设置</div>
      </div>
      <div class='update-button clickEle flexRow defaultRadius text-center ml-xs' (click)='jumpToHelp()'>
        <i nz-icon nzIconfont='icon_help_center' class='icon-setting mr-xs'></i>
        <div class='setting-button-text text-md'>版本更新</div>
      </div>
      <div class='space-mark'></div>
      <div class='logout-button clickEle'>
        <button nz-button class='log-out' nzType='primary' (click)='confirm()'>退出登录</button>
      </div>
    </div>
    <div class='flexFull'></div>
  </div>
  <div *ngIf='isHome' class='system-info'>
    <div class='text-default app-name pl-xl'>星晨管理系统</div>
    <div class='pl-xl mt-md text-default flexRow'>
      <div class='text-gray1'>成员:</div>
      <div class='ml-12 text-default'>{{ cache['count_user'] }}人</div>
    </div>
  </div>
  <div class='navigate-body' *ngIf='!isHome' [ngClass]="{'width-1200':smallPage,'width-all-page':!smallPage}">
    <nz-page-header class='site-page-header mt-xs mb-sm' [ngClass]="{ 'only-navigate': isSetting }">
      <!--      标题-->
      <nz-page-header-title class='title' (click)='goBack()' style='cursor: pointer'
      ><i class='mr-md' nz-icon nzIconfont='icon_back'></i>{{ title }}
      </nz-page-header-title>
      <nz-page-header-subtitle></nz-page-header-subtitle>
      <!--      面包屑-->
      <nz-breadcrumb nz-page-header-breadcrumb class='breadcrumb' [nzAutoGenerate]='true'
                     *ngIf='!isSetting'></nz-breadcrumb>
    </nz-page-header>
    <!--    菜单-->
    <div class='menu-list pl-xl scroll' *ngIf='show_menu'>
      <!--      <div *ngFor='let menu of showMenuData' class='text-center menu' (click)="clickMenu(menu['routing'])">-->
      <!--        {{ menu.name }}-->
      <!--      </div>-->
      <a
        *ngFor='let menu of showMenuData'
        class='text-center menu'
        [routerLink]="menu['routing']"
        routerLinkActive='menu-active'
        (click)="clickMenu(menu['routing'])"
      >
        {{ menu.name }}
      </a>
    </div>

    <!--    <div *ngIf="show_border" class="border-bottom-1"></div>-->
  </div>
  <div style='margin: 0 auto; background: #fff' class='flexFull'
       [ngClass]="{'width-1200':smallPage,'width-all-page':!smallPage}">
    <router-outlet></router-outlet>
  </div>
</div>
<my-confirm
  [title]='confirm_title'
  [visible]='pop_up'
  status='notice'
  [content]='confirm_content'
  (sure)='suredit()'
  (cancel)='canceldit()'
>
</my-confirm>
<div class='update-info-layer' *ngIf='updateInfo'>
  <div class='update-info-box selfRadius'>
    <div class='version-title'>{{ updateLog['title'] }}：</div>
    <div class='version-content mt-md selfRadius border-1'>
      <ul>
        <li *ngFor="let item of updateLog['log']">{{ item }}</li>
      </ul>
    </div>
    <div class='flexRow mt-lg'>
      <div class='flexFull'></div>
      <button nz-button nzType='primary' style='width: 124px' (click)='updateReceive()'>我知道了</button>
      <div class='flexFull'></div>
    </div>
  </div>
</div>
